<template>
  <div :class="{ 'is-locked': isLocked }">
    <div class="fork-card my-3" :class="{ 'bg-secondary': isCurrent }">
      <div class="row">
        <div class="col-10">
          <div class="title-wrapper">
            <p class="h6 pl-3 mb-0" :class="isCurrent ? 'text-white' : 'text-primary'">
              {{ isLocked || isCurrent ? mandatoryTitle : title }}
            </p>
          </div>
        </div>
      </div>

      <div class="d-flex justify-content-end mt-3" v-if="isCurrent">
        <b-button
          variant="outline-primary"
          class="mr-2"
          :disabled="!isCurrent || isLoading"
          @click="answerShortcut"
          size="sm"
          v-if="!isMandatory"
          >{{ trans("courses.new_dashboard.no_continue") }}</b-button
        >

        <b-button
          size="sm"
          variant="primary"
          :disabled="!isCurrent || isLoading"
          @click="trackMixpanelEventAndShowModal"
          >{{ cta }}</b-button
        >
      </div>
    </div>
    <hr />
  </div>
</template>

<script>
export default {
  name: "ShortcutCard",
  props: {
    isCurrent: Boolean,
    isMandatory: Boolean,
    noShortcut: Function,
    shortcutUsed: Boolean,
    isLocked: Boolean,
  },
  data() {
    return {
      isLoading: false,
    };
  },
  mounted() {
    if (this.isMandatory) {
      setTimeout(() => {
        this.trackMixpanelEventAndShowModal();
      }, 200);
    }
  },
  methods: {
    answerShortcut() {
      trackEvent("continueWithoutShortcut", {});

      this.isLoading = true;
      this.noShortcut();
    },
    trackMixpanelEventAndShowModal() {
      this.$bvModal.show("fork-modal");
      trackEvent("chooseShortcut", {});
    },
  },
  computed: {
    mandatoryTitle() {
      return this.isMandatory
        ? this.trans("courses.new_dashboard.want_shortcut_mandatory")
        : this.trans("courses.new_dashboard.want_shortcut");
    },
    title() {
      if (this.shortcutUsed) {
        if (this.isCurrent) {
          this.mandatoryTitle;
        }
        return this.trans("courses.new_dashboard.shorcut_used");
      } else {
        return this.trans("courses.new_dashboard.shorcut_not_used");
      }
    },
    cta() {
      return this.isMandatory
        ? this.trans("courses.new_dashboard.choose_module")
        : this.trans("courses.new_dashboard.try");
    },
  },
};
</script>

<style scoped lang="scss">
.fork-card {
  min-width: 345px;
  background: $color-light;
  padding: ($spacer * 1.4);
  flex-shrink: 0;
  @include border-radius(0.5rem);
}
.title-wrapper {
  padding-left: ($spacer * 2);
}
.is-locked {
  opacity: 0.7;
}
</style>
